
import { defineComponent, ref } from '@nuxtjs/composition-api';
import ProductFeatureGroupItem from '~/domains/product/components/ProductFeatureGroupItem';

export default defineComponent({
  name: 'ProductFeatureGroup',
  components: { ProductFeatureGroupItem },
  props: {
    feature: {
      type: Object,
      default: () => {},
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isOpenGroup = ref(props.isOpen);

    return { isOpenGroup };
  },
});
